import { DocumentsContent } from "@/components/documents/DocumentsContent";

export default function Documents() {
  return <DocumentsContent />;
}